"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexOutOfRangeError = void 0;
/**
 * Indicates that a given index is outside the bounds of whatever collection it is indexing.
 */
class IndexOutOfRangeError extends Error {
    constructor(union) {
        super(IndexOutOfRangeError.buildMessage(union));
        this[Symbol.toStringTag] = 'IndexOutOfRangeError';
        this.name = 'IndexOutOfRangeError';
    }
    static buildMessage(union) {
        if (union === undefined) {
            return 'The index is out of range. It must be non-negative and less than the size of the collection';
        }
        if (typeof union === 'number') {
            return `The index '${union}' is out of range. It must be non-negative and less than the size of the collection`;
        }
        return union;
    }
}
exports.IndexOutOfRangeError = IndexOutOfRangeError;
//# sourceMappingURL=index-out-of-range-error.js.map